import { useTranslation } from '@common/hooks/translation';
import React from 'react';
import './style.css';

export const IframePopup = ({ url, closePopup, onClose }) => {
  const handleOnPopupClose = () => {
    closePopup();
    onClose?.();
  }
  return (
    <div className="popup-content popup-frame">
      <div className="custom-popup-topbar">
        <i onClick={handleOnPopupClose} className="global-icon icon-Close custom-close-btn" />
      </div>
      
      <div className="popup-main-content">
        <iframe src={url} width="100%" height="100%" />
      </div>
    </div>
  );
};